import React, { useContext, useEffect, useState} from "react";
import { Grid, useMediaQuery } from "@material-ui/core";
import { FlowBackButton } from '../Core/Buttons/FlowBackButton';
import SummaryCard from "./SummaryCard";
import { OrangeButton } from "../Core/Buttons/OrangeButton";
import { QuoteContextStore } from "../../context/QuoteContext/QuoteContext";
import  {UnknownNNumberPopup}  from '../PopUps/UnknownNNumberPopup';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import summaryFormSchema from './schemas/SummaryFormSchema';
import dayjs from "dayjs";
import { SessionContextStore } from '../../context/SessionContext/SessionContext';
import summaryApi from "../../api/summary.api";
import { LoadingContextStore } from "../../context/LoadingContext/LoadingContext";
import { AlertContextStore } from "../../context/AlertContext/AlertContext";
import DownloadQuoteButton from "./DownloadQuoteButton";
import './SummaryStep.scss'
import { useParams } from 'react-router-dom';

const SummaryStep = () => {
    const { quoteId } = useParams();
    const { awaitWithLoading } = useContext(LoadingContextStore);
    const { showInfo } = useContext(AlertContextStore);
    const { finishSummary, aircrafts, is_approved, start_date } = useContext(QuoteContextStore);
    const [openPopup, setOpenPopup] = useState(false);
    const form = useForm({mode: 'onSubmit', defaultValues: { start_date }, resolver: yupResolver(summaryFormSchema)});
    const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
    

    useEffect(() => {
        if(!start_date) return;
        form.reset({start_date});
    },[start_date])

    const onSubmitSummary = async (data) => {
        const nNumber = aircrafts[Object.keys(aircrafts)[0]].n_number;
        if(nNumber && nNumber !== "") {
            const start_date = dayjs(data.start_date).format();
            await finishSummary({start_date, quoteId});
        } else {
            setOpenPopup(true);
        }
    }

    return (
        <div className="margin-top-xlarge margin-bottom-basic">
            <form onSubmit={form.handleSubmit(onSubmitSummary)}>
                <Grid className="margin-top-basic" container item justifyContent="space-between" xs={12} sm={12} md={12} lg={9}>
                    <Grid container item md={12} lg={12} xl={8}>
                        <FormProvider {...form}>
                            <SummaryCard/>
                        </FormProvider>
                    </Grid>
                    <Grid container className="margin-top-basic" item md={12} lg={12} xl={8} justifyContent="space-between">
                        {!is_approved && <FlowBackButton />}
                        <div>
                            <DownloadQuoteButton onClick={async () => {
                                const { data, ok } = await awaitWithLoading(summaryApi.downloadQuote(quoteId));
                                if(!ok) {
                                    showInfo({message: "We are finalizing your quote, please try again shortly.", title: "We are working on it!", ignoreCancel: true})
                                    return;
                                }
                                const link = document.createElement('a');
                                link.href = window.URL.createObjectURL(data);
                                link.download = "Your_Quote.pdf";
                                link.click();
                                link.remove();
                            }}>
                                {!isMobile ? 'Download quote' : 'Quote'}
                            </DownloadQuoteButton>
                            <OrangeButton type="submit">{!isMobile ? 'Save & Continue' : 'Continue'}</OrangeButton>
                        </div>
                    </Grid>
                </Grid>
            </form>
            <UnknownNNumberPopup 
                isOpen={openPopup}
                setIsOpen={setOpenPopup}
                title ="Registration Number Required" 
                message="To complete your policy, you must provide the registration number of your aircraft. Please type you aircraft N number:"
                confirmButtonText="Continue"
                cancelButtonText = "Cancel"
                />
        </div>
    )
}

export default SummaryStep;